import type { LinkProps as NextLinkProps } from 'next/link';
import React, { ComponentPropsWithoutRef, Ref } from 'react';
import {
    ButtonText,
    IconWrapper,
    StyledIcon,
    StyledLinkButton,
    Wrapper,
} from '~/shared/styles/Button/styles';
import { theme } from '~/theme';
import type { ButtonColorOptions } from './Button';

export type LinkButtonProps = Omit<NextLinkProps, 'as' | 'href'> &
    Omit<ComponentPropsWithoutRef<'a'>, keyof NextLinkProps> & {
        href?: NextLinkProps['href'];
        children: React.ReactNode;
        color?: ButtonColorOptions;
        customIcon?: React.ReactNode;
        noIcon?: boolean;
        variant?: 'fill' | 'stroke' | 'link';
        fullWidth?: boolean;
        disabled?: boolean;
        wrapperClass?: string;
        ref?: Ref<HTMLAnchorElement>;
    };

export const LinkButton = ({
    children,
    color = theme.colors.brandBlue,
    customIcon,
    wrapperClass,
    noIcon,
    variant = 'fill',
    href,
    ref,
    ...rest
}: LinkButtonProps) => {
    return (
        <StyledLinkButton color={color} ref={ref} variant={variant} href={href ?? '#'} {...rest}>
            <Wrapper className={wrapperClass}>
                <ButtonText>{children}</ButtonText>
                {noIcon ? null : (
                    <IconWrapper>{customIcon ? customIcon : <StyledIcon />}</IconWrapper>
                )}
            </Wrapper>
        </StyledLinkButton>
    );
};
